import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, RouterLink } from '@angular/router';
import { VulcanIconComponent } from '@eagle-i/vulcan-component-library';
import { from, switchMap } from 'rxjs';
import { GenRoleDefinition } from '../../../generated/serverModels/GenRoleDefinition';
import {
  RequestApiKeyModalComponent,
} from '../../../pages/profile/modals/request-api-key-modal/request-api-key-modal.component';
import { AuthService } from '../../../services/auth.service';
import { FeedbackModalComponent } from '../../../shared/modals/feedback-modal/feedback-modal.component';
import { LocationSelectionDropdownComponent } from '../location-selection-dropdown/location-selection-dropdown.component';

@Component({
  selector: 'tgrid-top-nav',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    RouterLink,
    VulcanIconComponent,
    ReactiveFormsModule,
    LocationSelectionDropdownComponent,
  ],
  templateUrl: './top-nav.component.html',
  standalone: true,
  styleUrl: './top-nav.component.scss',
})
export class TopNavComponent {
  private authenticatedUser = toSignal(AuthService.authenticatedUser);

  protected isImpersonating = computed(() => {
    return this.authenticatedUser()?.impersonating;
  });

  protected isUserManager = computed(() => {
    return this.authenticatedUser()?.hasRole(
      GenRoleDefinition.ROLE_USER_MANAGER,
    );
  });

  private authService = inject(AuthService);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  private popup = inject(MatSnackBar);

  constructor() { }

  public logout(): void {
    this.authService.logout().pipe(
      switchMap(() => from(this.router.navigate(['/login']))),
    ).subscribe({
      next: (success) => {
        if (!success) {
          console.error('Navigation to /login failed');
        }
      },
      error: (error) => {
        console.error('Navigation error:', error);
      },
    });
  }

  openFeedbackModal() {
    const config: MatDialogConfig = {
      disableClose: true,
      width: '400px',
    };
    this.dialog.open(FeedbackModalComponent, config);
  }

  unimpersonate() {
    this.authService.unimpersonate().subscribe({
      next: () => {
        this.popup
          .open('Unimpersonate Successful, Refreshing....', 'X', {
            panelClass: 'success',
            duration: 2_000,
          })
          .afterDismissed()
          .subscribe(() => window.location.reload());
      },
      error: () => {
        this.popup.open('Unimpersonate Failed', 'X', {
          panelClass: 'failure',
          duration: 2_000,
        });
      },
    });
  }

  protected requestApiKey() {
    const config: MatDialogConfig = {
      width: '500px',
    };
    this.dialog.open(RequestApiKeyModalComponent, config);
  }
}
